

import { gql } from '@apollo/client';

const GET_ALL_IRRIGATION_CHANNEL = gql`
  query GetAllIrrigationChannels {
    getAllIrrigationChannels {
      irrigation_channel_network_id
      kml_file
      name
      lat
      lng
      zoom
    }
  }
`
export default GET_ALL_IRRIGATION_CHANNEL